/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Grid } from '../../Grid';

const AppNavRowOld = (props) => {
  const classStyle = classnames('cmp-appnavrow', {
    'has-top-padding': props.hasTopPadding,
  });

  return (
    <div className={classStyle}>
      <Grid justifyContent="space-between" alignItems="center">
        {props.children}
      </Grid>
    </div>
  );
};
AppNavRowOld.propTypes = {
  children: PropTypes.any.isRequired,
  hasTopPadding: PropTypes.bool,
};

function createRow(className, height) {
  const AppNavRow = (props) => (
    <div className={className}>
      <Grid justifyContent="space-between" flexWrap="nowrap" alignItems={props.alignItems} style={{ height }}>
        {props.children}
      </Grid>
    </div>
  );
  AppNavRow.propTypes = {
    children: PropTypes.any,
    alignItems: PropTypes.string,
  };
  AppNavRow.defaultProps = {
    alignItems: 'center',
  };
  return AppNavRow;
}

const NavigationRow = createRow('cmp-appnavrow-navigation', '56px');
const TitleRow = createRow('cmp-appnavrow-title', null);
const GeneralRow = (props) => (
  <div className="cmp-appnavrow-general">
    {props.children}
  </div>
);
GeneralRow.propTypes = {
  children: PropTypes.any,
};
const SearchRow = (props) => (
  <div className="cmp-appnavrow-general search-row-padding">
    {props.children}
  </div>
);
SearchRow.propTypes = {
  children: PropTypes.any,
};

export {
  NavigationRow,
  TitleRow,
  GeneralRow,
  SearchRow,
};

export default AppNavRowOld;
